"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorDropdownItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var capitalize_1 = tslib_1.__importDefault(require("lodash/capitalize"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var util_1 = require("@gooddata/util");
var measureValueFilterOperator_1 = require("./helpers/measureValueFilterOperator");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var OperatorDropdownItem = /** @class */ (function (_super) {
    tslib_1.__extends(OperatorDropdownItem, _super);
    function OperatorDropdownItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (e) {
            var _a = _this.props, operator = _a.operator, onClick = _a.onClick;
            onClick(operator);
            e.preventDefault();
        };
        return _this;
    }
    OperatorDropdownItem.prototype.render = function () {
        var _a = this.props, intl = _a.intl, operator = _a.operator, selectedOperator = _a.selectedOperator, bubbleText = _a.bubbleText;
        var className = classnames_1.default("gd-list-item", "gd-list-item-shortened", "s-mvf-operator-" + util_1.stringUtils.simplifyText(operator), {
            "is-selected": selectedOperator === operator,
        });
        var title = intl.formatMessage({ id: measureValueFilterOperator_1.getOperatorTranslationKey(operator) });
        return (react_1.default.createElement("div", { className: className, onClick: this.handleOnClick },
            react_1.default.createElement("div", { className: "gd-icon-" + measureValueFilterOperator_1.getOperatorIcon(operator), title: title }),
            react_1.default.createElement("span", { title: title }, capitalize_1.default(title)),
            bubbleText ? this.renderBubble(bubbleText) : null));
    };
    OperatorDropdownItem.prototype.renderBubble = function (message) {
        return (react_1.default.createElement("div", { className: "tooltip-bubble" },
            react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { tagName: "div", showDelay: 400, hideDelay: 200 },
                react_1.default.createElement("div", { className: "inlineBubbleHelp" }),
                react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "tc bl" }] }, message))));
    };
    OperatorDropdownItem.defaultProps = {
        onClick: noop_1.default,
        bubbleText: null,
    };
    return OperatorDropdownItem;
}(react_1.default.PureComponent));
exports.OperatorDropdownItem = OperatorDropdownItem;
exports.default = react_intl_1.injectIntl(OperatorDropdownItem);
//# sourceMappingURL=OperatorDropdownItem.js.map